<form [formGroup]="externalLoginSettingsForm" (ngSubmit)="saveExternalLoginSettings()">
  <div class="form-group pt-2">
    <input type="checkbox" id="samlLoginEnabled" formControlName="samlLoginEnabled" />
    <label class="pl-1" for="samlLoginEnabled">
      {{ 'Settings::SamlLoginEnabled' | abpLocalization }}
    </label>
  </div>
  <div class="form-group mt-3">
    <label class="pl-1" for="samlLoginEndPoint">
      {{ 'Settings::SamlLoginEndPoint' | abpLocalization }}
    </label>
    <input
      type="text"
      id="samlLoginEndPoint"
      class="form-control form-control-sm"
      formControlName="samlLoginEndPoint" />
  </div>
  <div class="form-group mt-3">
    <label class="pl-1" for="samlDefaultRedirectEndPoint">
      {{ 'Settings::SamlDefaultRedirectEndPoint' | abpLocalization }}
    </label>
    <input
      type="text"
      id="samlDefaultRedirectEndPoint"
      class="form-control form-control-sm"
      formControlName="samlDefaultRedirectEndPoint" />
  </div>

  <div class="form-group mt-3">
    <button
      type="button"
      class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
      (click)="onImportFormClick($event)">
      <i class="far fa-file-import"></i>
      <span>{{ 'Settings::ImportCertificate' | abpLocalization }}</span>
    </button>
    <span *ngIf="selectedCertFile" class="ms-2 small text-muted">
      {{ selectedCertFile.name }}
    </span>
  </div>

  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>

<input
  id="samlCertSelector"
  type="file"
  class="d-none"
  style="display: none"
  (click)="$event.target.value = ''"
  (change)="onImportForm($event.target.files)"
  [attr.accept]="acceptFileExtensions.join(',')" />
